import {
  ReactBlog,
  TodoSnap,
  BananaTrans,
  CashRegister,
  EmojiInter,
  FunWIthTr,
  GrootTrans,
  MultiPortFolio,
  HowWellKnow,
  luckyBirth,
  Movies,
  NodeQuiz,
  BatsrapUIImg,
  ProfitLoss, batstore,
  Palindrome,
  PortfolioSnap,
  ClockPrj,
  CrudApp, batListSnap,
  CryptoKnight,
} from "./../imgs/project snaps/ProjectSnaps";

export const arrayOfProjects = [
  {
    imgURL: batstore,
    imgALT: "batstore",
    title: "Ecommerce App  ",
    date: "May 2022",
    desc: "Using this app you can create account, view products, use filters, and add products to    wishlist and cart.    It is created Using ReactJS, BatstrapUI, ContextAPI, etc.",
    tech: ["fab fa-react", "fab fa-css3-alt"],
    hostURL: "https://bat-store.netlify.app/",
    repoURL: "https://github.com/ZuberDunge/bat-store-ecom",
  }, {
    imgURL: batListSnap,
    imgALT: "batList",
    title: "batList - watchList extension for YouTube    ",
    date: "April 2022",
    desc: "It is created using React, YouTubeAPI, firebase. With batList, you can access videos anytime from any website or tab with a single click, you don't have to open YouTube first.",
    tech: ["fab fa-react", "fab fa-css3-alt"],
    hostURL: "https://chrome.google.com/webstore/detail/batlist-watchlist-extensi/jdiacjnlomdmccmgkkmeomeohhhdkhbg",
    repoURL: "https://github.com/ZuberDunge/batList-chrome-extension",
  }, {
    imgURL: BatsrapUIImg,
    imgALT: "BatstrapUI",
    title: "BatstrapUI - A CSS Library",
    date: "February 2022",
    desc: "A free, open source library that provides ready-to-use UI components that you can easily combine to build responsive web sites.",
    tech: ["fab fa-js", "fab fa-css3-alt", "fab fa-html5"],
    hostURL: "https://batstrap.netlify.app/",
    repoURL: "https://github.com/ZuberDunge/batstrap-ui",
  },
  {
    imgURL:
      "https://pbs.twimg.com/media/FH8vVzUVUAEcuNo?format=jpg&name=4096x4096",
    imgALT: "watcherXD",
    title: "watchListXD - Movies / Shows",
    date: "December 2021",
    desc: "A ReactJS Application created using TMDB API, AXIOS, Hooks, Router, etc. You can search any movie or show, filter by genre, every movie/show will give you its details with the cast, movie snaps, trailer, and similar movies/shows. ",
    tech: ["fab fa-react", "fab fa-css3-alt"],
    hostURL: "https://watch-list-zub.netlify.app/",
    repoURL: "https://github.com/ZuberDunge",
  },
  {
    imgURL: CryptoKnight,
    imgALT: "CryptoKnight",
    title: "CryptoKnight - Crypto Tracker",
    date: "November 2021",
    desc: "A ReactJS Application created using CoinGecko API, AXIOS, Context, Hooks, Router & Material UI ,etc. In the app you can search the coin, check current price, lowest and highest of the day, 7 day chart, market cap, total volume etc. It's responsive for all devices. ",
    tech: ["fab fa-react", "fab fa-html5"],
    hostURL: "https://crypto-tracker-rose.vercel.app/",
    repoURL: "https://github.com/ZuberDunge/crypto-tracker",
  },
  {
    imgURL: ReactBlog,
    imgALT: "React Blog",
    title: "Blog Project with React",
    date: "November 2021",
    desc: " This project includes React Router & Hooks mainly. I've created multiple components in React like Smart Components & Dummy & how to modify & do data operations within component using state variables.",
    tech: ["fab fa-react", "fab fa-css3-alt", "fab fa-html5"],
    hostURL: "https://react-blog-404.netlify.app/",
    repoURL: "https://github.com/ZuberDunge/react-blog",
  },
  {
    imgURL: CrudApp,
    imgALT: "CRUD",
    title: "CRUD APP",
    date: "November 2021",
    desc: "A ReactJS CRUD Application created using Context, Hooks, Router etc.   React CRUD Application in that:    Each student has id, name, age, course, batch. We can create, read, update &, delete the data.",
    tech: ["fab fa-react", "fab fa-css3-alt", "fab fa-html5"],
    hostURL: "https://crud-app-zeta.vercel.app/students",
    repoURL: "https://github.com/ZuberDunge/CRUD-APP",
  },
  {
    imgURL: MultiPortFolio,
    imgALT: " Multi Page Portfolio with React",
    title: " Multi Page Portfolio with React",
    date: "June 2021 - Present",
    desc: "  This is a Multi-Page Portfolio made with ReactJS. Responsive for all  devices with both dark & light theme.",
    tech: ["fab fa-react", "fab fa-css3-alt", "fab fa-html5"],
    hostURL: "https://zuberdunge.tech/",
    repoURL: "#",
  },
  {
    imgURL: PortfolioSnap,
    imgALT: " Single Page Portfolio React",
    title: " Single Page Portfolio React",
    date: "November 2021",
    desc: " This is a Single-Page Portfolio made with ReactJS.",
    tech: ["fab fa-react", "fab fa-css3-alt", "fab fa-html5"],
    hostURL: "https://portfolio-project-react.netlify.app/",
    repoURL: "https://github.com/ZuberDunge/React-Portfolio-Project",
  },
  {
    imgURL: TodoSnap,
    imgALT: " To Do App With JS",
    title: " To Do App With JS",
    date: "October 2021",
    desc: "   This project has created using HTML, CSS & JavaScript. Developed with mediaqueries, one of the finest concept in CSS to build         responsive applications. I've used multiple DOM functions which made         the static application as dynmaic appliction.",
    tech: ["fab fa-js", "fab fa-css3-alt", "fab fa-html5"],
    hostURL: "https://todo-app-zuber.netlify.app",
    repoURL: "https://github.com/ZuberDunge/Project-2",
  },
  {
    imgURL: ClockPrj,
    imgALT: "Clock Project",
    title: " Clock Project",
    date: "September 2021",
    desc: "   This is a clock project created using HTML, CSS and JS. In this     project it is updating the images and the innerText of that website        according to real-time and select options which is slected by the        user.",
    tech: ["fab fa-js", "fab fa-css3-alt", "fab fa-html5"],
    hostURL: "https://clock-by-zuber.netlify.app/",
    repoURL: "https://github.com/ZuberDunge/Clock-Project",
  },
  {
    imgURL: FunWIthTr,
    imgALT: "FunWithTriangles",
    title: " FunWithTriangles",
    date: "August 2021",
    desc: "    This is a fun app for learning about triangles, it has 4 parts : A        Triangle Quiz, Find Area of Triangle, Find Hypotenuse, Find if it's        a triangle or not.",
    tech: ["fab fa-js", "fab fa-css3-alt", "fab fa-html5"],
    hostURL: "https://fun-with-triangles-zuber.netlify.app/",
    repoURL: "https://github.com/ZuberDunge/FunWithTriangles",
  },
  {
    imgURL: ProfitLoss,
    imgALT: "Stock Return Calculator",
    title: " Stock Return Calculator",
    date: "August 2021",
    desc: "    This app shows how much profit or loss we are having on our stocks.        User need to enter stock urchase price per unit, stock current         price and stock units/quantity. App will show loss/profit in % and        absolute amount.",
    tech: ["fab fa-js", "fab fa-css3-alt", "fab fa-html5"],
    hostURL: "https://profit-loss-by-zuber.netlify.app/",
    repoURL: "https://github.com/ZuberDunge/ProfitOrLoss",
  },
  {
    imgURL: Palindrome,
    imgALT: "Palindrome Birthday",
    title: " Palindrome Birthday",
    date: "August 2021",
    desc: " This is a fun app to check if your birthday is palindrome or not. If        it is not palindrome, then it will show nearest palindrome date and        by how many days it got missed.",
    tech: ["fab fa-js", "fab fa-css3-alt", "fab fa-html5"],
    hostURL: "https://palindrome-birthday-zuber.netlify.app/",
    repoURL: "https://github.com/ZuberDunge/Palindrome-Birthday",
  },
  {
    imgURL: CashRegister,
    imgALT: "Cash Register Manager",
    title: " Cash Register Manager",
    date: "August 2021",
    desc: "This is an application to know how many notes of currency 1, 5, 10,        20, 100, 500, 2000 to return to the customer. This app takes input        of bill amount and cash given by customer. And shows output of no of        notes to return.",
    tech: ["fab fa-js", "fab fa-css3-alt", "fab fa-html5"],
    hostURL: "https://cash-register-by-zuber.netlify.app/",
    repoURL: "https://github.com/ZuberDunge/Cash-Register",
  },
  {
    imgURL: luckyBirth,
    imgALT: "Is your birthdate Lucky?",
    title: " Is your birthdate Lucky?",
    date: "August 2021",
    desc: "  Find out if your birthday your lucky number or not by entering your        DOB and lucky number.(This is just an app, you create your own        luck.) (Also, We Don't store your data.)",
    tech: ["fab fa-js", "fab fa-css3-alt", "fab fa-html5"],
    hostURL: "https://is-your-b-day-lucky.netlify.app/",
    repoURL: "https://github.com/ZuberDunge/Lucky-Birthday",
  },
  {
    imgURL: GrootTrans,
    imgALT: "Groot Translater",
    title: " Groot Translater",
    date: "July 2021",
    desc: " This is a translation app to convert english to Groot language using funtranslation API.        groot speak in groot language in marvel movies. This is a fun game        to talk like minions in friends.",
    tech: ["fab fa-js", "fab fa-css3-alt", "fab fa-html5"],
    hostURL: "https://groot-translater-zuber.netlify.app/",
    repoURL: "https://github.com/ZuberDunge/Groot-TranslateR",
  },
  {
    imgURL: Movies,
    imgALT: "Marvel Movie Recommendation App",
    title: " Marvel Movie Recommendation App",
    date: "July 2021",
    desc: " It is a ReactJS app. This shows you the movies you want to see by        clicking an option.",
    tech: ["fabfa-react", "fab fa-css3-alt", "fab fa-html5"],
    hostURL: "https://csb-pu0ix.netlify.app/",
    repoURL: "https://github.com/ZuberDunge/Movie-Recommendation-ReactApp",
  },
  {
    imgURL: EmojiInter,
    imgALT: "Emoji Interpreter",
    title: " Emoji Interpreter",
    date: "July 2021",
    desc: " This is a fun app to search Emoji or click Emoji listed on the page        to know meaning of Emoji. This app is created using React-js.",
    tech: ["fabfa-react", "fab fa-css3-alt", "fab fa-html5"],
    hostURL: "https://csb-241w5.netlify.app/",
    repoURL: "https://github.com/ZuberDunge/Emoji-interpreteR",
  },
  {
    imgURL: BananaTrans,
    imgALT: "Talk Like Minions (Banana Translater)",
    title: " Talk Like Minions (Banana Translater)",
    date: "July 2021",
    desc: "  This is a translation app to convert english to banana language using funtranslation API.        Minions speak in banana language in Animated movie Despicable me.        This is a fun game to talk like minions in friends.",
    tech: ["fab fa-js", "fab fa-css3-alt", "fab fa-html5"],
    hostURL: "https://banana-translation-by-zuber.netlify.app/",
    repoURL: "https://github.com/ZuberDunge/Banana-Translation",
  },
  {
    imgURL: HowWellKnow,
    imgALT: "How well do you know me?",
    title: " How well do you know me?",
    date: "July 2021",
    desc: "  A CLI app built with nodeJS. You can send this to your friends and        find out who knows you better.",
    tech: ["fab fa-node-js"],
    hostURL: "https://tinyurl.com/know-zuber",
    repoURL: "https://github.com/ZuberDunge/Quiz-1",
  },
  {
    imgURL: NodeQuiz,
    imgALT: "Marvel Quiz",
    title: " Marvel Quiz",
    date: "July 2021",
    desc: "   A CLI app built with nodeJS. A small fun game, you can send this to        your friends and find out who is the die hard fan of MARVEL.",
    tech: ["fab fa-node-js"],
    hostURL: "https://tinyurl.com/MCU-Quiz2",
    repoURL: "https://github.com/ZuberDunge/Quiz-2",
  },
];

export function createPorjectCard(item) {
  return (
    <div className="project-item">
      <img style={{ width: "100%" }} src={item.imgURL} alt="React Portfolio" />
      <h1 className="project-name-heading">{item.title}</h1>
      <small>{item.date}</small>

      <p>{item.desc}</p>
      <p>
        Tech used : <i className={item.tech[0]}></i>{" "}
        <i className={item.tech[1]}></i> <i className={item.tech[2]}></i>
      </p>
      <div className="buttons-project">
        <a target="blank" className="link primary-button" href={item.hostURL}>
          Live Demo
        </a>
        <a className="link secondary-button" href={item.repoURL}>
          Source Code
        </a>
      </div>
    </div>
  );
}
